'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _themeCurrency = require('@shopify/theme-currency');

var currency = _interopRequireWildcard(_themeCurrency);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shopCurrency = (0, _jquery2.default)('body').attr('data-shop-currency');

var bindUIActions = function bindUIActions() {
  var $printOptions = (0, _jquery2.default)(_dom2.default.printOption);
  $printOptions.on('click', function (event) {
    var $printOption = (0, _jquery2.default)(this);
    var selected = $printOption.hasClass('selected');
    if (selected) {
      return true;
    }
    var $printButton = $printOption.find(_dom2.default.printButton);

    var print_type = $printOption.attr('data-print-type');
    (0, _jquery2.default)('.pdp__images--print-type.active').removeClass('active');
    (0, _jquery2.default)('.pdp__images--print-type[data-print-type="' + print_type + '"]').addClass('active');
    $printOptions.removeClass('selected');
    (0, _jquery2.default)(_dom2.default.printButton).removeClass('selected');
    $printOption.addClass('selected');
    $printButton.addClass('selected');

    if (print_type === 'original') {
      (0, _jquery2.default)('.original-badge').addClass('is-active');
      (0, _jquery2.default)('[data-finish-warning]').addClass('is-active');
    } else {
      (0, _jquery2.default)('.original-badge').removeClass('is-active');
      (0, _jquery2.default)('[data-finish-warning]').removeClass('is-active');
    }

    var variantId = $printOption.attr('data-variant-id');
    (0, _jquery2.default)('.pdp__product-id').val(variantId);

    // update width and height
    (0, _jquery2.default)('.pdp__dimensions span').addClass('hide').removeAttr('data-product-dimensions');
    (0, _jquery2.default)('.pdp__dimensions .pdp__dimensions--' + print_type).removeClass('hide').attr('data-product-dimensions', '');

    // update tags
    (0, _jquery2.default)('.pdp__meta-details .pdp__meta-tags').addClass('hide').removeAttr('data-product-meta');
    (0, _jquery2.default)('.pdp__meta-details .pdp__meta-tags--' + print_type).removeClass('hide').attr('data-product-meta', '');

    // update price
    var price = parseFloat($printOption.attr('data-price'));
    var compare_price = parseFloat($printOption.attr('data-compare-price'));

    if (price) {
      var frameID = _jsCookie2.default.get('finish_type');
      var final_price = void 0;
      var final_compare_price = void 0;
      if (frameID) {
        var framePrice = parseFloat(_jsCookie2.default.get('finish_price'));
        var total_price = framePrice + price;
        final_price = currency.formatMoney(total_price, "${{amount}} " + shopCurrency);
        if (compare_price > 0) {
          var total_compare_price = framePrice + compare_price;
          final_compare_price = currency.formatMoney(total_compare_price, "${{amount}} " + shopCurrency);
        }
      } else {
        final_price = currency.formatMoney(price, "${{amount}} " + shopCurrency);
        if (compare_price > 0) {
          final_compare_price = currency.formatMoney(compare_price, "${{amount}} " + shopCurrency);
        }
      }

      (0, _jquery2.default)(_dom2.default.atcPrice).html(final_price);
      (0, _jquery2.default)(_dom2.default.productPrice).html(final_price);

      if (compare_price > 0) {
        (0, _jquery2.default)(_dom2.default.comparePrice).html(final_compare_price).removeClass('hide');
      } else {
        (0, _jquery2.default)(_dom2.default.comparePrice).addClass('hide');
      }
    }
  });
};

var init = exports.init = function init() {
  bindUIActions();
};